<script setup>
import { useSlots, computed, Comment, Fragment, Text } from 'vue';

const props = defineProps({
    titulo: {
        type: String,
        required: true
    },
    descricao: {
        type: String,
        default: ''
    },
    carregamento: {
        type: Boolean,
        default: false
    },
    returnTrailRota: {
        type: String,
        default: 'rotaOrigem'
    },
    botaoVoltarVisivel: {
        type: Boolean,
        default: true
    },
    semBorda: {
        type: Boolean,
        default: false
    },
    paddingDireitaCorpo: {
        type: String,
        default: ''
    }
});

const classesCabecalho = computed(() => props.semBorda
    ? 'border-round-xl flex flex-column justify-content-between'
    : 'border-1 surface-border p-4 border-round-xl flex flex-column justify-content-between');

const classesCorpo = computed(() => props.semBorda ? '' : 'pt-6 px-4');

const estiloCorpo = computed(() => props.paddingDireitaCorpo
    ? { paddingRight: props.paddingDireitaCorpo }
    : null);

const slots = useSlots();

function hasContent(vnodes) {
    return vnodes.some(vnode => {
        if (vnode.type === Comment) return false;
        if (vnode.type === Text) return vnode.children?.trim() !== '';
        if (vnode.type === Fragment) {
            return Array.isArray(vnode.children) && hasContent(vnode.children);
        }
        // É um elemento ou componente real
        return true;
    });
}

const temConteudoCabecalhoTop = computed(() => {
    const slot = slots['cabecalho-top'];
    if (!slot) return false;
    const vnodes = slot();
    return hasContent(vnodes);
});

const temConteudoCabecalhoBottom = computed(() => {
    const slot = slots['cabecalho-bottom'];
    if (!slot) return false;
    const vnodes = slot();
    return hasContent(vnodes);
});

const temConteudoCabecalho = computed(() => {
    const slot = slots['cabecalho'];
    if (!slot) return false;
    const vnodes = slot();
    return hasContent(vnodes);
});
</script>

<template>
    <ReturnTrail v-if="props.botaoVoltarVisivel" :action="props.returnTrailRota" icon />

    <Carregador :carregando="props.carregamento" class="card flex justify-content-center mt-5 w-full">
        <section :class="classesCabecalho">
            <div v-if="temConteudoCabecalhoTop">
                <slot name="cabecalho-top" />
            </div>

            <slot v-if="!props.carregamento && temConteudoCabecalho" name="cabecalho" />

            <h1 class="text-900 font-semibold text-2xl my-2" style="max-width: 40rem;">
                {{ props.titulo }}
            </h1>

            <p v-if="props.descricao" class="text-500 font-medium text-xs m-0">
                {{ props.descricao }}
            </p>

            <div v-if="temConteudoCabecalhoBottom"
                class="mt-3 flex flex-wrap md:flex-row justify-content-start align-items-center gap-2">
                <slot name="cabecalho-bottom" />
            </div>
        </section>
    </Carregador>

    <section v-if="!props.carregamento && $slots['corpo']" :class="classesCorpo" :style="estiloCorpo">
        <slot v-if="$slots['corpo']" name="corpo" />
    </section>
</template>